var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFutures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_futures") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-235, -81)",
    stroke: "#0E1C39",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(239, 85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7825446,22.150487 L11.5790769,22.150487 C9.88551693,22.150487 8.2263217,21.6726451 6.79217904,20.7718785 L3.50823402,18.7092749 C2.74512861,18.2299782 1.75359309,18.3324536 1.10464103,18.9576867 C0.619096029,19.4254852 0.604709644,20.1983228 1.07250814,20.6838678 C1.13648559,20.7502723 1.2077805,20.8092146 1.28502886,20.859567 L4.19563616,22.7567726 C6.94360089,24.5479638 10.1171172,25.5790325 13.3931097,25.7450121 L16.2444434,25.8894762 C17.9341715,25.975087 19.553254,26.594204 20.8689948,27.657847 L20.9908213,27.7563314 C22.1855265,28.7221294 23.9320337,28.5609914 24.9298603,27.3929038 L26.675255,25.3496889 C27.3926926,24.5098335 27.2934533,23.2473981 26.453598,22.5299605 C26.4100546,22.4927641 26.3649338,22.4574551 26.3183602,22.4241311 L22.8874361,19.9692599 C22.2085246,19.4834898 21.3946416,19.2223043 20.5598402,19.2223043 L11.4558403,19.2223043 C10.5534533,19.2223043 9.76283521,19.8265837 9.52596965,20.6973287 L9.26913324,21.6414888 L9.26913324,21.6414888",
    id: "\\u8DEF\\u5F84-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39163077,15.2909367 L2.39163077,3 C2.39163077,1.34314575 3.73477652,-1.57345071e-15 5.39163077,-1.77635684e-15 L15.3767075,-4.4408921e-16 C16.7875165,-7.03250616e-16 17.9312031,1.14368665 17.9312031,2.55449564 L17.9312031,4.10899128 C17.9312031,4.66127603 18.3789184,5.10899128 18.9312031,5.10899128 L20.4852725,5.10899128 C21.8958461,5.10899128 23.0393419,6.25248709 23.0393419,7.66306065 L23.0393419,16.2909367 L23.0393419,16.2909367",
    id: "\\u8DEF\\u5F84-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.82525743,
    y1: 8.82157185,
    x2: 15.5947917,
    y2: 8.82157185,
    id: "\\u8DEF\\u5F84-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.82525743,
    y1: 14.3215719,
    x2: 19.0649246,
    y2: 14.3215719,
    id: "\\u8DEF\\u5F84-8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFutures);
export default __webpack_public_path__ + "static/media/icon_futures.25c464a3ff1447bc08159e86f7845f71.svg";
export { ForwardRef as ReactComponent };